import Debug from 'debug'
import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useFeatures } from '@jotta/grpc-connect-client/config'
import { useUsername } from '@jotta/grpc-connect-client/customer'
import { md5 } from '@jotta/utils/md5'
import posthog from 'posthog-js'

const debug = Debug('jotta:webapp:tracking')

let posthogInitialized = false

declare global {
  // eslint-disable-next-line no-var
  var _paq: any[] | undefined
}

export function useTracking() {
  const location = useLocation()
  useEffect(() => {
    const paq = globalThis._paq
    if (paq) {
      debug('Track page view to %s', location.pathname)
      paq.push(['setCustomUrl', location.pathname])
      paq.push(['trackPageView'])
    }
  }, [location])

  const { posthogEnabled } = useFeatures()
  const username = useUsername()

  useEffect(() => {
    if (username && posthogEnabled) {
      md5(username).then(identity => {
        if (!posthogInitialized) {
          posthogInitialized = true
          posthog.init('phc_vv5MhMyXt6AhDbmFUfwkaI8e0pOzz9cMF4aJghp3miI', {
            api_host: 'https://eu.i.posthog.com',
            persistence: 'memory', // https://posthog.com/tutorials/cookieless-tracking#step-2-configure-persistence
            bootstrap: {
              distinctID: identity,
            },
          })
        } else {
          posthog.identify(identity)
        }
      })
    }
  }, [username, posthogEnabled])
}
